import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaListMem } from "app/features/general/operativa/items/guias/listados/guias/list/listmem";

export interface Props {
    viaje: models.ViajeZEDto;
}

const resource = resources.ViajeZE;
interface BotonStatusViaje {
    /**Status en el que este botón debe de aparecer */
    status: models.StatusViajeZE;
    /**Accion del resource que se debe de ejecutar cuando el usuario le de click al botón */
    onClick: (idViaje: number) => Promise<void> | void;
    text: string;
    icon: string;
}

const botones: BotonStatusViaje[] = [
    {
        status: models.StatusViajeZE.IniciadoApp,
        icon: fa("sign-out"),
        text: "Dar salida",
        onClick: resource.DarSalidaViaje
    }, {
        status: models.StatusViajeZE.FinalizadoAppMovil,
        icon: fa("sign-in"),
        text: "Dar llegada",
        onClick: resource.MarcarFinalizadoPendienteDescarga
    }, {
        status: models.StatusViajeZE.FinalizadoPendienteDescarga,
        icon: fa("truck"),
        text: "Terminó descarga de camión",
        onClick: resource.MarcarPendienteVerificacion,
    }, {
        status: models.StatusViajeZE.PendienteVerificacion,
        icon: fa("check"),
        text: "Verificar guias y contrarecibos",
        onClick: () => history.go("./verificar"), //Viaja a la pantalla de verificación del viaje
    }
];

/**Muestra el botón para cambiar el viaje de EAD al siguiente status */
export class CambiarStatusViajeButton extends React.PureComponent<Props> {
    render() {
        const viaje = this.props.viaje;
        const boton = first(botones, x => x.status == viaje.Status);

        return (
            boton ?
                <kea.Button
                    style="success"
                    iconClass={boton.icon}
                    onClick={() => boton.onClick(viaje.IdRegistro)}
                >
                    {boton.text}
                </kea.Button>
                :
                null
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/edit/cambiostatus.tsx